import SidebarItem from "./SidebarItem"
import items from "../data/sidebar.json"
import './Sidebar.css';
import logo from '../assets/GlobalLogo_NTTDATA_FutureBlue_RGB.png'
import React, { useEffect, useState } from "react";
import axios from "axios";

export default function Sidebar() {
    const [authByToken, setAuthByToken] = useState('');
    const [userRole, setUserRole] = useState('');

    const loadUserByToken = async (token) => {
      const result = await axios.get(`https://lbhaw84n6b.execute-api.ap-southeast-3.amazonaws.com/xcp/auth/find-by-token?token=${token}`);
      setAuthByToken(result.data[0]);
      
      const data = result.data[0]

      if(data.xcp_role_code === 'XCPRLE-001'){
        setUserRole("External")
      }else if(data.xcp_role_code === 'XCPRLE-002'){
        setUserRole("Sales")
      }else if(data.xcp_role_code === 'XCPRLE-003'){
        setUserRole("Service Delivery")
      }else if(data.xcp_role_code === 'XCPRLE-004'){
        setUserRole("Network")
      } else if(data.xcp_role_code === 'XCPRLE-005'){
        setUserRole("Operation")
      }
  }
  

    useEffect(() => {
        // Retrieve the token from local storage  
        const storedToken = localStorage.getItem('token');

        // Check if token is not null or undefined
        if (storedToken) {
            loadUserByToken(storedToken)
                .then(response => {                   
                })
                .catch(error => {
                    console.error('Error loading user:', error);
                });
        } 
    }, []);

    const filterItemsByRole = (items, role) => {
        return items.filter(item => item.roles.includes(role)).map(item => {
            if (item.childrens) {
                item.childrens = filterItemsByRole(item.childrens, role);
            }
            return item;
        });
    }

    const filteredItems = filterItemsByRole(items, userRole);

    return (
        <div className="sidebar">
            <div className="side-bar-img"><img src={logo} alt="Logo" /></div>
            <div className="side-bar-title"><h6>NTT Indonesia </h6></div>
            <div className="side-bar-title"><h6>Cross Connect Portal</h6></div> 
            <div className="side-bar-username"><h6>{authByToken.pic_name ? authByToken.pic_name : authByToken.xcp_internal_name}</h6></div>         
            {filteredItems.map((item, index) => <SidebarItem key={index} item={item} />)}
        </div>
    )
}


